/* eslint-disable */
import React from "react";

import * as S from "./styles";
interface Props {
  title?: string;
  description?: string;
}

const PageDescription: React.FC<Props> = ({ title, description }) => {
  return (
    <S.Container>
      <S.Title>{title}</S.Title>
      <S.Description>{description}</S.Description>
    </S.Container>
  );
};

export default PageDescription;
